import { WORKFLOW_EDGE_OPTIONS } from "./workflowBuilderTheme";
import { LINEAR_HANDLE } from "./workflowPaletteConstants";

/** Fixed id for the UI-only canvas entry node — never persisted in API definition.nodes. */
export const WORKFLOW_START_NODE_ID = "__workflow_canvas_start__";

export const WORKFLOW_START_NODE_TYPE = "workflowStart";

export const WORKFLOW_START_EDGE_PREFIX = "__start_edge__";

export const WORKFLOW_START_DEFAULT_POSITION = { x: 80, y: 200 };

export function isWorkflowStartCanvasNode(node) {
  return node?.id === WORKFLOW_START_NODE_ID || node?.type === WORKFLOW_START_NODE_TYPE;
}

export function isWorkflowStartCanvasEdge(edge) {
  return (
    edge?.source === WORKFLOW_START_NODE_ID
    || (typeof edge?.id === "string" && edge.id.startsWith(WORKFLOW_START_EDGE_PREFIX))
  );
}

/** Place the Start marker to the left of the connected first step when possible. */
export function resolveWorkflowStartNodePosition(nodes = [], workflowStartId = "") {
  const target = nodes.find((node) => node.id === workflowStartId);
  if (target?.position) {
    return {
      x: target.position.x - 220,
      y: target.position.y + 24,
    };
  }
  return WORKFLOW_START_DEFAULT_POSITION;
}

export function getWorkflowNodes(nodes = []) {
  return nodes.filter((node) => !isWorkflowStartCanvasNode(node));
}

export function getWorkflowStartNode(nodes = []) {
  return nodes.find(isWorkflowStartCanvasNode);
}

/** Prepends the UI-only Start marker before workflow steps. */
export function withWorkflowStartNode(workflowNodes = [], position = WORKFLOW_START_DEFAULT_POSITION) {
  return [createWorkflowStartCanvasNode(position), ...getWorkflowNodes(workflowNodes)];
}

export function setWorkflowStartNodePosition(nodes = [], position = WORKFLOW_START_DEFAULT_POSITION) {
  return nodes.map((node) => (
    isWorkflowStartCanvasNode(node) ? { ...node, position } : node
  ));
}

/** UI-only canvas entry node — lives in React Flow nodes state; stripped on save. */
export function createWorkflowStartCanvasNode(position = WORKFLOW_START_DEFAULT_POSITION) {
  return {
    id: WORKFLOW_START_NODE_ID,
    type: WORKFLOW_START_NODE_TYPE,
    position,
    data: { label: "Start" },
    draggable: true,
    selectable: false,
    deletable: false,
    focusable: false,
    connectable: true,
  };
}

export function createWorkflowStartCanvasEdge(targetNodeId) {
  return {
    id: `${WORKFLOW_START_EDGE_PREFIX}${targetNodeId}`,
    source: WORKFLOW_START_NODE_ID,
    target: targetNodeId,
    sourceHandle: LINEAR_HANDLE,
    ...WORKFLOW_EDGE_OPTIONS,
  };
}
